import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { CheckCircle2, AlertTriangle, Sparkles, Info, CalendarDays } from "lucide-react";

export default function EditingPolicyCard() {
  const [policy, setPolicy] = useState(null);

  useEffect(() => {
    api.get("/business/editing-policy").then((r) => setPolicy(r.data)).catch(() => {});
  }, []);

  if (!policy) return null;

  const { can_edit, subscription_active, subscription_expires_at, reason, ai_changes_used, ai_changes_limit } = policy;

  let tone, Icon, badge;
  if (can_edit) {
    tone = "violet";
    Icon = CheckCircle2;
    badge = "Suscripción activa — puedes publicar";
  } else {
    tone = "rose";
    Icon = AlertTriangle;
    badge = "Suscripción inactiva";
  }

  const toneCls = {
    violet: "bg-gradient-to-br from-[#F5F3FF] to-[#EDE9FE] border-[#DDD6FE] text-[#5B21B6]",
    rose: "bg-gradient-to-br from-rose-50 to-rose-100 border-rose-200 text-rose-900",
  }[tone];

  const aiRemaining = ai_changes_limit - (ai_changes_used || 0);

  return (
    <div className={`mt-6 border rounded-2xl p-5 ${toneCls}`} data-testid="editing-policy-card">
      <div className="flex items-start gap-3 flex-wrap">
        <div className="w-10 h-10 rounded-xl bg-white/70 grid place-items-center shrink-0">
          <Icon className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="overline text-[11px] opacity-80">Estado de tu suscripción</div>
          <div className="font-display text-xl tracking-tight mt-0.5">{badge}</div>
          <p className="text-base mt-2 leading-relaxed">{reason}</p>

          {subscription_expires_at && (
            <div className="mt-3 flex items-center gap-2 text-sm">
              <CalendarDays className="w-4 h-4" />
              <span>Vence: <strong>{subscription_expires_at}</strong></span>
            </div>
          )}

          {can_edit && (
            <div className="mt-2 flex items-center gap-2 text-sm">
              <Sparkles className="w-4 h-4" />
              <span>
                Generaciones IA disponibles: <strong>{aiRemaining} de {ai_changes_limit}</strong>
              </span>
            </div>
          )}
        </div>
      </div>

      <details className="mt-4 group">
        <summary className="cursor-pointer text-sm font-medium hover:underline inline-flex items-center gap-1">
          <Info className="w-3.5 h-3.5" /> ¿Cómo funciona?
        </summary>
        <ol className="mt-3 space-y-2.5 text-base list-decimal pl-5 leading-relaxed">
          <li>Cada pago de <strong>$199 MXN</strong> activa tu suscripción por <strong>30 días</strong> desde la aprobación.</li>
          <li>Mientras tu suscripción esté activa, puedes diseñar o actualizar tu anuncio <strong>en cualquier momento</strong>.</li>
          <li>Tienes hasta <strong>{ai_changes_limit} generaciones con IA</strong> por ciclo de pago. Se reinician con cada renovación aprobada.</li>
        </ol>
      </details>
    </div>
  );
}
